export default "__VITE_ASSET__CshWC2Ji__"